import { ExitMarginOrderType, LeverageDirection, TradeType } from "@gql/offer";
import { Price } from "@models";
import { MoSuccessVisionBannerState } from "@modules/web3/components/mo-success-vision-component/mo-success-vision-banner-state.model";

export interface PriceConversions {
	price: Price;
	conversions: iPreselectFiatValue[];
}

export interface iPreselectFiatValue {
	amount: number;
	isMax: boolean;
}

// add new route if needed here
export enum CheckoutRouteName {
	AssetSelect = "asset-selection",
	Appropriateness = "appropriateness-test",
	Best2Terms = "best-2-terms",
	AssetWallets = "asset-wallets",
	AmountSelect = "amount-selection",
	SelectFiat = "fiat-selection",
	Summary = "buy-summary",
	Success = "buy-success",
	SelectPaymentMethod = "payment-method-selection",
	AccountConfirmation = "account-confirmation",
	DepositConfirmation = "deposit-confirmation",
	CheckoutDepositProcessing = "checkout-deposit-processing",
	CheckoutDepositPaymentOnHold = "checkout-deposit-payment-on-hold",
	CheckoutDepositPaymentUnderReview = "checkout-deposit-payment-under-review",
	CheckoutDepositPaymentFailed = "checkout-deposit-payment-failed",
	CheckoutDepositVisaCCNotSupported = "checkout-deposit-visa-cc-not-supported",
	CheckoutDepositPaymentTakingLong = "checkout-deposit-payment-taking-long"
}

// add new query params if needed here
export enum CheckoutQueryParamName {
	WalletGuid = "walletId",
	AssetId = "assetId",
	FiatId = "fiatId",
	FiatWalletId = "fiatWalletId",
	BuyAmount = "amount",
	Success = "success",
	LtxType = "ltxType",
	TxPending = "txPending",
	selectedAmountType = "selectedAmountType",
	paymentMethod = "paymentMethod",
	paymentMethodId = "paymentMethodId",
	IsPriceOrder = "isPriceOrder",
	HeaderSwitch = "HeaderSwitch",
	ShowVisionBanner = "showVisionBanner",
	VisionBannerState = "visionBannerState",
	VisionFeeAmount = "visionFeeAmount",
	leverage = "leverage",
	currencyOverride = "currencyOverride", //this is used for amount, currencySelection, payment method selection and summary
	isMarginTrading = "isMarginTrading", //this is used for summary and success page
	stableCoinPid = "stableCoinId",
	tradeType = "tradeType",
	assetPid = "assetPid",
	fiatPid = "fiatPid",
	mtSellMax = "mtSellMax",
	selectedPill = "selectedPill",
	isPercentagePreSelected = "isPreselected",
	LeverageDirection = "leverageDirection",
	AmountString = "amountString",
	targetPrice = "targetPrice",
	exitMarginOrderType = "exitMarginOrderType",
	QuestionnaireLabel = "questionnaireLabel",
	GoToDeposit = "goToDeposit",
	FromDeposit = "fromDeposit",
	CoolOffEnd = "coolOffEnd"
}

// add to collection here if there is a new QueryParamName
export interface CheckoutQueryParamsCollection {
	[CheckoutQueryParamName.WalletGuid]: string;
	[CheckoutQueryParamName.AssetId]: string;
	[CheckoutQueryParamName.FiatId]: string;
	[CheckoutQueryParamName.FiatWalletId]: string;
	[CheckoutQueryParamName.BuyAmount]: number;
	[CheckoutQueryParamName.Success]: boolean;
	[CheckoutQueryParamName.LtxType]: string;
	[CheckoutQueryParamName.selectedAmountType]: AmountType;
	[CheckoutQueryParamName.paymentMethod]: PaymentMethod;
	[CheckoutQueryParamName.TxPending]: boolean;
	[CheckoutQueryParamName.paymentMethodId]: string | "none";
	[CheckoutQueryParamName.IsPriceOrder]?: boolean;
	[CheckoutQueryParamName.HeaderSwitch]?: boolean;
	[CheckoutQueryParamName.ShowVisionBanner]?: boolean;
	[CheckoutQueryParamName.VisionBannerState]?: MoSuccessVisionBannerState;
	[CheckoutQueryParamName.VisionFeeAmount]?: string;
	[CheckoutQueryParamName.leverage]?: number;
	[CheckoutQueryParamName.currencyOverride]?: CurrencyOverrideType;
	[CheckoutQueryParamName.isMarginTrading]?: boolean;
	[CheckoutQueryParamName.stableCoinPid]?: string;
	[CheckoutQueryParamName.tradeType]?: TradeType;
	[CheckoutQueryParamName.assetPid]?: string;
	[CheckoutQueryParamName.fiatPid]?: string;
	[CheckoutQueryParamName.mtSellMax]?: boolean;
	[CheckoutQueryParamName.selectedPill]?: string;
	[CheckoutQueryParamName.isPercentagePreSelected]?: boolean;
	[CheckoutQueryParamName.LeverageDirection]?: LeverageDirection;
	[CheckoutQueryParamName.AmountString]?: string;
	[CheckoutQueryParamName.targetPrice]?: string;
	[CheckoutQueryParamName.exitMarginOrderType]?: ExitMarginOrderType;
	[CheckoutQueryParamName.QuestionnaireLabel]?: string;
	[CheckoutQueryParamName.GoToDeposit]?: boolean;
	[CheckoutQueryParamName.FromDeposit]?: boolean;
	[CheckoutQueryParamName.CoolOffEnd]?: string;
}

export enum AmountType {
	asset = "asset",
	fiat = "fiat"
}

export enum PaymentMethod {
	fiatwallet = "fiatwallet",
	wiretransfer = "wiretransfer"
}

export enum CurrencyOverrideType {
	fiat = "fiat",
	stableCoin = "stableCoin",
	baseAsset = "baseAsset"
}
